import img from '@images/inmarket-logo-small.png';

type HelpModalImageProps = {
  class?: string;
};

const HelpModalImage = (props: HelpModalImageProps) => (
  <img alt="error" src={img} className={props.class} />
);

export default HelpModalImage;
